import { c as _c } from "react/compiler-runtime";
import React from "react";
const Star = t0 => {
  const $ = _c(6);
  const {
    className: t1,
    filled: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const filled = t2 === undefined ? true : t2;
  const t3 = filled ? "#FFC107" : "#EEE";
  let t4;
  if ($[0] !== t3) {
    t4 = <g clipPath="url(#clip0_204_6135)"><path d="M15.5754 6.22267L10.6568 5.47134L8.4521 0.775337C8.28743 0.42467 7.7121 0.42467 7.54743 0.775337L5.34343 5.47134L0.424766 6.22267C0.0207661 6.28467 -0.140567 6.776 0.142766 7.066L3.7161 10.7287L2.87143 15.9067C2.8041 16.318 3.24343 16.6267 3.60677 16.4247L8.0001 13.9967L12.3934 16.4253C12.7534 16.6253 13.1968 16.3227 13.1288 15.9073L12.2841 10.7293L15.8574 7.06667C16.1408 6.776 15.9788 6.28467 15.5754 6.22267Z" fill={t3} /></g>;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs><clipPath id="clip0_204_6135"><rect width="16" height="16" fill="white" transform="translate(0 0.5)" /></clipPath></defs>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== className || $[4] !== t4) {
    t6 = <><svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">{t4}{t5}</svg></>;
    $[3] = className;
    $[4] = t4;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export default Star;